import { SpaceBetween } from "@cloudscape-design/components-themed";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { RateUpdateForm } from "../components/merchant-info-inquiry/RateUpdateForm";

/* 
　料率更新
 */
const RateUpdate = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.RATE_SETTING);

  return (
    <SpaceBetween size="l">
      <RateUpdateForm />
    </SpaceBetween>
  );
};

export default RateUpdate;
